import { applyTransformations } from "../calculation/Calculation";
import { TransformationTags } from "../calculation/TransformationTags";
import {
  GLOBAL_INITIAL_STATE,
  PlayerContextState,
  THIS_RUN_INITIAL_STATE,
} from "../PlayerContext";
import { registerTimeTickListener } from "./TimeTick";

export function loadTotalTimePlayed() {
  registerTimeTickListener(
    "TotalTimePlayed",
    (state, timeElapsedSec, isWarp) => {
      if (!state.global) {
        state.global = GLOBAL_INITIAL_STATE;
      }
      if (!state.thisRun) {
        state.thisRun = THIS_RUN_INITIAL_STATE;
      }
      state.global.secondsPlayed += timeElapsedSec;
      state.thisRun.secondsPlayed += timeElapsedSec;
      state.global.thisWorldSecondsPlayed += timeElapsedSec;
      if (!isWarp) {
        // To calculate active play time we need to de-transform the timeElapsedSec
        const speed = applyTransformations(
          [TransformationTags.GameSpeed],
          state,
          1.0,
        );
        if (state.global.activeSecondsPlayed != "untracked") {
          state.global.activeSecondsPlayed += timeElapsedSec / speed;
        }
        if (state.thisRun.activeSecondsPlayed != "untracked") {
          state.thisRun.activeSecondsPlayed += timeElapsedSec / speed;
        }
        state.global.thisWorldActiveSecondsPlayed += timeElapsedSec / speed;
      }
      return state;
    },
  );
}

export function getTotalSecondsPlayed(state: PlayerContextState) {
  return state?.global?.secondsPlayed || 0;
}

export function getTotalActiveSecondsPlayed(state: PlayerContextState) {
  return state?.global?.activeSecondsPlayed || 0;
}

export function getSecondsPlayed(state: PlayerContextState) {
  return state?.thisRun?.secondsPlayed || 0;
}
